import { Component, computed, inject } from '@angular/core';
import { GcTextComponent, IpoTranslatePipe } from '@ip-only/front-end-library';
import { SignatureDataService } from '../../../../../signature/service/signature-data/signature-data.service';
import { CustomerSigningData } from '../../../../../signature/signature.entities';

@Component({
  selector: 'app-customer-information',
  standalone: true,
  imports: [GcTextComponent, IpoTranslatePipe],
  templateUrl: './customer-information.component.html',
  styleUrl: './customer-information.component.scss',
})
export class CustomerInformationComponent {
  signatureDataService = inject(SignatureDataService);

  customerInformationData =
    this.signatureDataService.storedCustomerInformationData;
  customerInformation = computed(() => {
    const data = this.customerInformationData();
    const keys: (keyof CustomerSigningData)[] = [
      'address',
      'propertyDesignation',
      'name',
      'email',
      'mobileNumber',
      'homeNumber',
    ];

    return keys.map((key) => ({
      label: 'signingSummary.' + key,
      data: data[key] ?? '-',
    }));
  });
}
